/*
	Central configuration file for its frontend

    @file         config.js
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge

*/

export const dockerVersion = false;


// export const domain = "https://itsLocal/";
// export const domain = "https://its.tforge4merck.de/";
export const domain = window.location.origin + '/';


export const PAGE = {
    login:  1,
    home:   2,
    liPro:  3,
    camTe:  4,
    benMa:  5,
    liProLight:  6
};

export const checkConnectionInterval_ms = 10000; // check all 10 seconds connection to backend
